/**
 * Define micro exam mixin
 *
 * @author sohyun.ahn@emcast.com
 */
export const microExamMixin = {
  methods: {
    routerGoPrev() {
      let type = this.$route.query.type;
      if (type === "formal-evolution") {
        let status = this.$route.query.status;
        if (status === "LEARNING" || status === "COMPLETION") {
          this.$router.push({
            name: "MicroDegreeView",
            params: this.$route.params.learnId,
            query: this.$route.query
          });
        } else {
          this.$router.go(-1);
        }
      } else {
        //this.$router.go(-1)
        this.$router.push({
          name: this.$route.matched[this.$route.matched.length - 2].name,
          params: this.$route.params,
          query: {
            status: this.$route.query.status,
            examresult: "getscore"
          }
        });
      }
    },

    // 형성평가 시험 응시 확인(check lesson exam)
    isMicroExamTake() {
      let routeName = this.$route.name;
      return routeName.indexOf("Micro") >= 0;
    },

    // 정규평가 시험 응시 확인(check final exam)
    isFinalExamTake() {
      let routeName = this.$route.name;
      return routeName.indexOf("Final") >= 0;
    },

    // 시험 시작(Start Exam)
    startExam() {
      let routeName = "";
      if (this.isMicroExamTake()) {
        routeName = "MicroExamTake";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalMicroExamTake";
      }

      this.$router.push({
        name: routeName,
        params: this.$route.params,
        query: this.$route.query
      });
    },

    // 시험 결과로 이동(move exam result)
    moveExamResult() {
      let routeName = "";
      if (this.isMicroExamTake()) {
        routeName = "MicroExamResult";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalMicroExamResult";
      }

      this.$router.push({
        name: routeName,
        params: this.$route.params,
        query: this.$route.query
      });
    },

    // 시험 피드백으로 이동(move exam feedback)
    moveExamFeedback() {
      let routeName = "";
      if (this.isMicroExamTake()) {
        routeName = "MicroExamFeedback";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalMicroExamFeedback";
      }

      this.$router.push({
        name: routeName,
        params: { paperId: this.paperId },
        query: this.$route.query
      });
    },

    // 문항 이이제기로 이동(move question issue)
    moveIssue() {
      let routeName = "";
      if (this.isMicroExamTake()) {
        routeName = "MicroExamFeedbackIssue";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalMicroExamFeedbackIssue";
      }
      this.$router.push({
        name: routeName,
        params: { questionId: this.questionId },
        query: this.$route.query
      });
    },

    // 문항 질문하기로 이동(move question FAQ)
    moveQuestion() {
      let routeName = "";
      if (this.isMicroExamTake()) {
        routeName = "MicroExamFeedbackQuestion";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalMicroExamFeedbackQuestion";
      }

      // console.log('currentGroupIndex',this.$route.query)
      this.$router.push({
        name: routeName,
        params: {
          questionId: this.questionId
        },
        query: {
          listType: this.$route.query.listType,
          tb: this.currentGroupIndex
        }
      });
    }
  }
};
